import { createUseBosQuery } from '@bos/api';

import { logQueryError } from '../logger/apiErrors/logQueryError';

export const useAppQuery = createUseBosQuery({
	onLogError: logQueryError,
});
